
export default {
  name: 'FooterLayout',
  data() {
    return {
      showPrivacy: false,
      showISMS: false,
    }
  },
  methods: {
    fn_gotoHome() {
      this.$router.push('/')
    },
  },
}
